import { createContext } from 'react';
export const CommonDataContext = createContext({
    symptomPriorities: [],
    symptomPrioritiesById: {},
    featureFlags: {},
});
